import { render, staticRenderFns } from "./CsCollapse.vue?vue&type=template&id=4f3723e2&"
import script from "./CsCollapse.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsCollapse.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports